export const requestTypes = [
  {
    label: "CONVERSION",
    value: "conversion",
  },
  {
    label: "ADJUSTMENT_FOR_TRANSFER",
    value: "adjustment_for_transfer",
  },
  {
    label: "ADJUSTMENT_FOR_LOST_ITEMS",
    value: "adjustment_for_lost_items",
  },
  {
    label: "ADJUSTMENT_FOR_DAMAGED_ITEMS",
    value: "adjustment_for_damaged_items",
  },
  {
    label: "SUPPLIES_CONSUMPTION",
    value: "adjustment_for_supplies_consumption",
  },
  {
    label: "ADJUSTMENT_FOR_EXCESS_GOOD_STOCK",
    value: "adjustment_for_excess_good_stock",
  },
];
